import { createI18n } from 'vue-i18n'
import messages from './index'
import brand from '@/config/brand'

const i18n = createI18n({
  legacy: false, //处理报错Uncaught (in promise) SyntaxError: Not available in legacy mode (at message-compiler.esm-bundler.js:54:19)
  locale: localStorage.getItem('language') || "zhCN", // 注意locale属性！
  messages,
  fallbackWarn: false,
  missingWarn: false,
  silentFallbackWarn: false,
  silentTranslationWarn: false
})

// 用品牌配置覆盖系统名称相关文案（多套部署）
Object.keys(messages).forEach((locale) => {
  i18n.global.mergeLocaleMessage(locale, {
    message: {
      title: brand.pageTitle,
      loginPage: {
        title: brand.systemName,
        subtitle: brand.subtitle,
      }
    }
  })
})

export default i18n
